import { DecimalPipe } from '@angular/common';

export const currenciesNoDp = ['UGX', 'JPY', 'HUF', 'IDR'];

export function transformToCurrentCurrency(value: string | null, currency: string): string | null {
  const decimalPipe = new DecimalPipe('en-GB'); // Specify British locale

  if (value === null) {
    return null;
  }

  const numberValue = parseFloat(value);
  if (isNaN(numberValue)) {
    return null;
  }

  let digitsInfo = '1.2-2'; // Default for most currencies

  if (currenciesNoDp.includes(currency)) {
    digitsInfo = '1.0-0'; // No decimal places for currencies in the noDp list
    return decimalPipe.transform(Math.floor(numberValue), digitsInfo); // Use Math.floor to truncate without rounding
  }

  return decimalPipe.transform(numberValue, digitsInfo);
}

export function handleCurrencyDecimals(
  value: string,
  currency: string,
  withTransform = false,
): string | null {
  // Remove non-numeric characters except for the decimal point.
  const re = /[^0-9.]/g;
  let newValue = value.replace(re, '');

  // Ensure the decimal point is not the first character and not duplicated.
  const dotIndex = newValue.indexOf('.');
  if (dotIndex === 0) {
    newValue = newValue.substring(1); // Remove leading decimal point
  } else if (dotIndex !== -1) {
    const parts = newValue.split('.');
    // Only keep the first part and the first two decimals (if any)
    parts[0] = parts[0].replace(/\./g, ''); // Remove any other dots in the integer part
    if (currenciesNoDp.includes(currency)) {
      newValue = parts[0]; // For currencies with no decimal places
    } else if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].substring(0, 2); // Limit decimal places to 2
    }
    newValue = parts.join('.'); // Join the parts back
  }
  if (withTransform) {
    return transformToCurrentCurrency(newValue, currency);
  }
  return newValue;
}

export function formatInputDecimals(value: string, currency: string) {
  let formattedValue = '';
  const decimalPipe = new DecimalPipe('en-GB'); // Specify British locale
  let digitsInfo = '1.2-2';
  if (currenciesNoDp.includes(currency)) {
    digitsInfo = '1.0-0'; // No decimal places for currencies in the noDp list
  }
  if (typeof value === 'string') {
    formattedValue = decimalPipe.transform(+value.replace(/,/g, ''), digitsInfo) ?? '';
  } else {
    formattedValue = decimalPipe.transform(value, digitsInfo) ?? '';
  }
  return formattedValue;
}
